import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import EditIcon from '@mui/icons-material/Edit';
import { Avatar, CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import { getImageUrl, putPublic } from '../../data/aws/s3/UserBlobs';
const debug = false;
/**
 * Automatically handles displaying and saving an avatar image for a Valid Business Object
 * @param imageContainingVob - The Business object to contain an image. Doesn't need to have the image formally set up
 */
export const AvatarSelector = (props) => {
    'use no memo';
    // Modifying component props or hook arguments is not allowed. Consider using a local variable instead.
    // `props` cannot be modified
    const [imageUrl, setImageUrl] = useState('');
    useEffect(() => {
        getImageUrl(props.imageContainingVob, true).then((res) => {
            debug && console.log('Retrieved Image', res);
            if (typeof res === 'string')
                setImageUrl(res);
            else
                setImageUrl('');
        });
    }, [props.imageContainingVob.sk, props.imageContainingVob.primaryS3Image?.key]);
    const [uploadProgress, setUploadProgress] = useState(0);
    const handleFileUpload = async (e) => {
        debug && console.log(e.target.files);
        const fileList = e.target.files;
        const directoryString = `${props.imageContainingVob.sk}/`;
        if (fileList) {
            for (let i = 0, numFiles = fileList.length; i < numFiles; i++) {
                const file = fileList[i];
                const progressCallback = (progressEvent) => {
                    const { loaded, total } = progressEvent;
                    setUploadProgress((loaded / total) * 100);
                    if (loaded === total) {
                        setTimeout(() => setUploadProgress(0), 1000);
                    }
                };
                try {
                    const uploadRes = await putPublic(directoryString, file, progressCallback);
                    const clone = structuredClone(props.imageContainingVob);
                    clone.primaryS3Image = uploadRes;
                    props.transactionFunctions.saveObject(clone);
                    props.userFunctions.addObjectsToState([clone]);
                    debug && console.log('uploadRes', uploadRes);
                }
                catch (error) {
                    console.log('Error uploading file: ', error);
                }
            }
        }
    };
    /** Styles */
    const inputStyle = {
        position: 'absolute',
        top: '0px',
        left: '0px',
        width: '100%',
        height: '100%',
        borderRadius: '50%',
        cursor: 'pointer',
        opacity: 0,
    };
    const centerAlign = {
        display: 'grid',
        justifyContent: 'center',
        alignItems: 'center',
    };
    return (_jsxs("div", { style: { position: 'relative', overflow: 'hidden', display: 'inline-block' }, children: [_jsx(Avatar, { src: imageUrl, alt: props.imageContainingVob.name ?? '?', sx: { ...props.sx } }), uploadProgress == 0 ? (props.editable && (_jsxs("div", { style: {
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    top: 0,
                    left: 0,
                    ...centerAlign,
                }, children: [_jsx("div", { style: {
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            borderRadius: '50%',
                            width: '3em',
                            height: '3em',
                            ...centerAlign,
                        }, children: _jsx(EditIcon, { style: { color: 'white' } }) }), _jsx("input", { accept: "image/*", type: "file", onChange: (e) => handleFileUpload(e), style: inputStyle })] }))) : (_jsx(CircularProgress, {}))] }));
};
